import { useTranslation } from 'react-i18next';

import { Button } from '../../../shared/ui/Button';
import styles from './ConfirmDialog.module.css';

interface ConfirmDialogProps {
  title: string;
  message: string;
  /** Дополнительные следствия действия (AC-14: proration, AC-14b: потеря функций). */
  notes?: string[];
  onConfirm: () => void;
  onDismiss: () => void;
}

// PARA-131 (AD-3) — один компонент на три диалога: отмена (AC-12),
// возобновление (AC-13c) и смена тарифа (AC-14/14b). Тексты приходят пропами
// из словаря. В shared/ui НЕ выносится: единственный потребитель — биллинг.
export function ConfirmDialog({
  title,
  message,
  notes = [],
  onConfirm,
  onDismiss,
}: ConfirmDialogProps): JSX.Element {
  const { t } = useTranslation('billing');

  return (
    <div className={styles.scrim}>
      <div className={styles.dialog} role="dialog" aria-modal="true" aria-label={title}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>
        {notes.map((note) => (
          <p key={note} className={styles.note}>
            {note}
          </p>
        ))}
        <div className={styles.actions}>
          <Button variant="ghost" fullWidth onClick={onDismiss}>
            {t('dialogs.dismiss')}
          </Button>
          <Button fullWidth onClick={onConfirm}>
            {t('dialogs.confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
}
